/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { TableCell, TableRow } from 'carbon-components-react';
import React from 'react';

import { RequestParameters } from './RequestParameters';
import { ResponseProperties } from './ResponseProperties';

interface ExpandedEndpointRowProps {
  /**
   *
   */
  headers: any;
  /**
   *
   */
  row: any;
}
export const ExpandedEndpointRow = ({
  headers,
  row
}: ExpandedEndpointRowProps) => {
  return (
    <TableRow
      key={`${row.id}-params-and-responses`}
      className="CatalogOpenApiDataTable__row ParametersAndResponses">
      <TableCell />
      <TableCell colSpan={headers.length}>
        <div className="ParametersAndResponses-left CatalogOpenApiDataTable__operation-container">
          <RequestParameters row={row} />
        </div>
        <div className="ParametersAndResponses-right">
          <ResponseProperties row={row} />
        </div>
      </TableCell>
    </TableRow>
  );
};

export default ExpandedEndpointRow;
